import React from 'react';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemSecondaryAction from '@mui/material/ListItemSecondaryAction';
import ListItemText from '@mui/material/ListItemText';
import { ChevronRightOutlined } from '@rakutenfrance/material-ui-icons';
import { colorPalette } from '../../colorPalette';
export const HelpLink = ({ link: { label, url, newWindow = false } }) => {
    let target = undefined;
    if (newWindow) {
        target = '_blank';
    }
    return (React.createElement(List, { dense: true, sx: { borderBottom: '1px solid #d1d1d1' }, "data-qa": "help-link" },
        React.createElement(ListItem, { button: true, component: "a", href: url, target: target, rel: "noreferrer noopener", sx: {
                paddingLeft: 0,
                '&:hover': {
                    backgroundColor: 'transparent',
                },
            } },
            React.createElement(ListItemText, { primary: label }),
            React.createElement(ListItemSecondaryAction, null,
                React.createElement(IconButton, { edge: "end", sx: { padding: 0 } },
                    React.createElement(ChevronRightOutlined, { fontSize: "small", style: { color: colorPalette.gray900 } }))))));
};
